import axios from 'axios';
const domain = location.host.includes('bytesansokan')
  ? 'bytesansokan'
  : 'movito';
let baseUrl = `https://api.${domain}.se`;

if (location.host.includes('localhost')) {
  baseUrl = 'http://localhost:3001';
} else if (location.host.includes('test') || location.host.includes('demo')) {
  baseUrl = `https://dev-api.${domain}.se`;
}

export const apiEndpoint = baseUrl;

const apiInstance = axios.create({
  baseURL: apiEndpoint,
  withCredentials: true,
  'content-Type': 'application/json'
});

export default apiInstance;
